'use client';
import { useEffect, useRef } from 'react';
import { BaseModal } from '../BaseModal/BaseModal';
import { Button } from '../../Buttons/Button/Button';
import styles from './ConfirmModal.module.css';

interface ConfirmModalProps {
	isOpen: boolean;
	title: string;
	message: string;
	confirmText?: string;
	cancelText?: string;
	onConfirm: () => void;
	onCancel: () => void;
	variant?: 'danger' | 'warning' | 'info';
}

export const ConfirmModal = ({
	isOpen,
	title,
	message,
	confirmText = 'Confirmar',
	cancelText = 'Cancelar',
	onConfirm,
	onCancel,
	variant = 'danger',
}: ConfirmModalProps) => {
	const cancelButtonRef = useRef<HTMLButtonElement>(null);

	useEffect(() => {
		if (isOpen) {
			cancelButtonRef.current?.focus();
		}
	}, [isOpen]);

	useEffect(() => {
		const handleEscape = (e: KeyboardEvent) => {
			if (e.key === 'Escape' && isOpen) {
				onCancel();
			}
		};

		document.addEventListener('keydown', handleEscape);
		return () => document.removeEventListener('keydown', handleEscape);
	}, [isOpen, onCancel]);

	return (
		<BaseModal
			isOpen={isOpen}
			onClose={onCancel}
			title={title}
			actions={
				<>
					<Button
						variant="cancel"
						ref={cancelButtonRef}
						className={styles.actionButton}
						onClick={onCancel}
						type="button"
					>
						{cancelText}
					</Button>
					<Button
						variant={
							variant === 'danger' ? 'dangerSolid' : variant === 'warning' ? 'warning' : 'info'
						}
						className={styles.actionButton}
						onClick={onConfirm}
						type="button"
					>
						{confirmText}
					</Button>
				</>
			}
		>
			<p className={styles.message}>{message}</p>
		</BaseModal>
	);
};
